import type { PreGameRoutine } from 'generated/openapi';
import { type ReactNode } from 'react';
import { z } from 'zod';

const preGameRoutineEnum = z.enum<PreGameRoutine[]>([
  'NONE',
  'CAFFEINATE',
  'PLAY_MUSIC',
  'WARM_UP',
]);

import Bullseye from '@/assets/icons/bullseye.svg?react';
import FoldedHands from '@/assets/icons/folded-hands.svg?react';
import Headphone from '@/assets/icons/headphone.svg?react';
import HotBeverage from '@/assets/icons/hot-beverage.svg?react';

export interface PreGameRoutineOption {
  id: PreGameRoutine;
  icon: ReactNode;
  label: string;
  description: string;
}

export const PRE_GAME_ROUTINE_MAP = new Map<
  PreGameRoutine,
  PreGameRoutineOption
>([
  [
    'CAFFEINATE',
    {
      id: 'CAFFEINATE',
      icon: <HotBeverage />,
      label: 'Coffee first',
      description: 'Need that caffeine boost',
    },
  ],
  [
    'PLAY_MUSIC',
    {
      id: 'PLAY_MUSIC',
      icon: <Headphone />,
      label: 'Hype music',
      description: 'Blast tunes to lock in',
    },
  ],
  [
    'WARM_UP',
    {
      id: 'WARM_UP',
      icon: <Bullseye />,
      label: 'Aim warm-up',
      description: 'Practice makes perfect',
    },
  ],
  [
    'NONE',
    {
      id: 'NONE',
      icon: <FoldedHands />,
      label: 'Queue and pray',
      description: 'No prep, just vibes',
    },
  ],
]);

export const PRE_GAME_ROUTINE_OPTIONS: PreGameRoutineOption[] = Array.from(
  PRE_GAME_ROUTINE_MAP.values(),
);

export const preGameRoutineSchema = preGameRoutineEnum;
